
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import TextSearch from '@/components/molecules/TextSearch.vue'
import AcademyListTable from '@/components/organisms/manage/AcademyListTable.vue'
import PageLinkButton from '@/components/organisms/PageLinkButton.vue'
import { AcademyList } from '@/models/manage/AcademyList'

/**
 * 塾一覧パネル
 */
@Component({
  components: {
    PanelFrame,
    TextSearch,
    AcademyListTable,
    PageLinkButton,
  },
})
export default class AcademyListPanel extends Vue {
  /** 検索欄 */
  @Ref()
  textSearch!: TextSearch

  /** 塾一覧テーブル */
  @Ref()
  academyListTable!: AcademyListTable

  /** 塾一覧 */
  @Prop()
  private academyList!: AcademyList[]

  /** ページ数 */
  @Prop()
  private pageLength!: number

  /** 現在のページ */
  @Prop()
  private currentPage!: number

  /** 検索ボタン押下時の処理 */
  @Prop()
  private eventClickSearch!: () => void

  /** 編集エリア表示イベント */
  @Prop()
  private eventClickEditButton!: (event: Event, academyId: number) => Promise<void>

  /** ページリンクボタン押下時のイベント */
  @Prop()
  private changePage!: (value: number) => void

  /**
   * 検索文字列
   *
   * @returns 入力された文字列
   */
  public textInputed(): string {
    return this.textSearch.text
  }
}
